import "../css/app.css";

import { initTheme } from "./theme.js";
import { initNav } from "./nav.js";

initTheme();

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initNav, { once: true });
} else {
  initNav();
}
